import * as go from 'gojs';
import { GuidedDraggingTool } from '../tools/guided-dragging-tool/guided-dragging-tool';

export const toggleGuidedDraggingTool = (diagram: go.Diagram, showGuidelines: boolean) => {
  const draggingTool = diagram.toolManager.draggingTool;
  if (draggingTool instanceof GuidedDraggingTool) {
    draggingTool.isGuidelineEnabled = showGuidelines;
  }
};
